import React from 'react';
import L from 'leaflet';
import { Marker, Popup, Polyline } from 'react-leaflet';

const VehicleTrackMarkers = ({ vehicleLocations, timeIndex, zoomedIn }) => {
    const currentLocation = vehicleLocations[timeIndex];

    if (!currentLocation) return null;

    const renderPopupContent = (vehicleLocation) => (
        <div style={{ textAlign: 'left' }}>
            <h3>{vehicleLocation.user?.nameuser || 'Unknown Vehicle'}</h3>
            <p><strong>ID:</strong> {vehicleLocation.user?.username || 'Unknown User'}</p>
            <p><strong>Latitude:</strong> {vehicleLocation.latitude}</p>
            <p><strong>Longitude:</strong> {vehicleLocation.longitude}</p>
            <p><strong>Heading:</strong> {vehicleLocation.heading}</p>
            <p><strong>Speed:</strong> {vehicleLocation.speed}</p>
            <p><strong>Battery:</strong> {vehicleLocation.battery} %</p>
            <p><strong>Charging:</strong> {vehicleLocation.charge ? 'Yes' : 'No'}</p>
            <p><strong>Time:</strong> {vehicleLocation.time || 'N/A'}</p>
            <p><strong>Date:</strong> {vehicleLocation.date || 'N/A'}</p>
            <div style={{ textAlign: "right" }}>
                <i
                    className="fa-solid fa-street-view"
                    style={{ cursor: "pointer", fontSize: "20px", color: "gray" }}
                    onClick={() => {
                        const mapUrl = `https://www.google.com/maps/place/${vehicleLocation.latitude}+${vehicleLocation.longitude}/@${vehicleLocation.latitude},${vehicleLocation.longitude},150m`;
                        window.open(mapUrl, "_blank");
                    }}
                ></i>
            </div>
        </div>
    );

    return (
        <>
            {/* Full Route Line (Background) */}
            {vehicleLocations.length > 0 && (
                <Polyline
                    positions={vehicleLocations.map(loc => [loc.latitude, loc.longitude])}
                    color="gray"
                    weight={2}
                    opacity={0.3}
                />
            )}

            {/* Current Vehicle Marker */}
            <Marker
                position={[currentLocation.latitude, currentLocation.longitude]}
                icon={L.divIcon({
                    className: 'custom-div-icon',
                    html: `
                        <div style="position: relative; text-align: center;">
                            <div style="
                                position: absolute;
                                top: -20px;
                                left: 50%;
                                transform: translateX(-50%);
                                background-color: rgba(255, 255, 255, 0.8);
                                padding: 2px 5px;
                                border-radius: 3px;
                                font-size: 12px;
                                font-weight: bold;
                                color: #333;
                                white-space: nowrap;
                                border: 1px solid #ccc;
                                box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
                            ">
                                ${currentLocation.speed || 0} km/h
                            </div>
                            ${
                        zoomedIn
                            ? `<div style="
                                            position: absolute; 
                                            bottom: 50px; 
                                            left: 50%; 
                                            width: 120px;
                                            transform: translateX(-50%); 
                                            background-color: rgba(255, 255, 255, 0.7); 
                                            padding: 2px 5px; 
                                            border: 1px solid #ff0059;
                                            border-radius: 4px; 
                                            font-size: 13px; 
                                            font-weight: bold; 
                                            color: #ff0059;
                                            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
                                            z-index: 1000;
                                            white-space: nowrap;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                        ">
                                        ${currentLocation.user?.nameuser || "Unknown Vehicle"}
                                        </div>`
                            : ""
                    }
                            <div style="
                                transform: rotate(${(currentLocation.heading || 0) % 360 - 90}deg) scaleY(${currentLocation.heading > 180 ? -1 : 1});
                                width: 55px;
                                height: 45px;
                                display: inline-block;
                                background: url('/ice-truck.png') no-repeat center;
                                background-size: contain;
                            "></div>
                        </div>
                    `,
                    iconSize: [55, 45],
                })}
            >
                <Popup>{renderPopupContent(currentLocation)}</Popup>
            </Marker>

            {/* Red Line for Behind Locations (Full Traveled Path) */}
            {vehicleLocations.length > 0 && (
                <Polyline
                    positions={vehicleLocations.slice(0, timeIndex + 1).map(loc => [loc.latitude, loc.longitude])}
                    color="red"
                    weight={5}
                />
            )}

            {/* Green Line for Ahead Locations (Future Path) */}
            {vehicleLocations.length > 0 && (
                <Polyline
                    positions={vehicleLocations.slice(timeIndex).map(loc => [loc.latitude, loc.longitude])}
                    color="green"
                    weight={3}
                    opacity={0.6}
                    dashArray="5, 10"
                />
            )}
        </>
    );
};

export default VehicleTrackMarkers;
